module.exports = __webpack_public_path__ + "img/coin6.7a15db0.webp";